import { UntypedFormGroup } from '@angular/forms';

import { Person } from '@app/src/app/people';

import { peopleToIssuedFilters } from '@modules/behavior-manager/components/bm-reports/utils';

import { getFilterGroupControlKey } from '../../../constants';
import { ScheduledReportType } from '../../../types';

export const setIssuedOnPeopleSelect = (
  people: Partial<Person>[],
  form: UntypedFormGroup,
  {
    reportType,
    issuedToKey,
    issuedByKey,
  }: {
    reportType: ScheduledReportType;
    issuedToKey: string;
    issuedByKey: string;
  },
) => {
  const { issuedTo, issuedBy } = peopleToIssuedFilters(people, reportType as any);
  const issuedToControl = form.get(getFilterGroupControlKey(issuedToKey));
  const issuedByControl = form.get(getFilterGroupControlKey(issuedByKey));

  issuedToControl.setValue(issuedTo.length ? issuedTo.map(p => p.hash) : null);
  issuedByControl.setValue(issuedBy.length ? issuedBy.map(p => p.hash) : null);
};
